define('models/user/register/status',[
    'backbone',
    'models/shared/lookups/systext'
], function (Backbone, SystemText) {
    var CreatePwStatus = Backbone.Model.extend({
        urlRoot: function(){
            return pf.checkStatus + '/SimpleReg/' + this.UG;
        },
        save: function(attributes, options){
            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.UG = this.attributes.UG;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        },
        initialize: function(options){
            options = options || {};

            this.UG = options.UG;
        }
    });
    return CreatePwStatus;
});

